import React, { Component } from 'react'
import {
    Card,
    Row,
    Col,
    Button,
    Input,
    Table
} from "reactstrap";
import LessonCard from "../LessonCard";

  
const ListItems = ({handleRightColums, value, index, addItemsLesson}) => {
   return (
        <React.Fragment>
            <tr>
            {addItemsLesson && <td style={{ backgroundColor: '#e6e7e8',  border: 0 }}><div className='author-lesson-checkbox side-checkbar'>
                                            <Input style={{ left: '28px', top: '-7px'}} type="checkbox" />
                                            <span class="checkmark"></span>
                                        </div></td>}
                <td>{value.itemCode}</td>
                <td>{value.itemType}</td>
                <td>{value.nodes}</td>
                <td>{value.tags}</td>
                <td><div className='preview-td' dangerouslySetInnerHTML={{ __html: value.preview }}></div></td>
            </tr>
            {!addItemsLesson && <div id={`row-side-menu-${index}`} style={{width: '84px', left: '-62px'}} className='row-side-menu'>
                    <Button className="icon-btn p-1"><i className="edit-deck-logic-icon" /></Button>
                    <Button onClick={() => handleRightColums('simulateItem', value)} className='icon-btn p-1'><i className='screen-eye-icon'></i></Button>
                    <Button onClick={() => handleRightColums('previewItem', value)} className='icon-btn p-1'><i className='preview-icon'></i></Button>
                </div>}
        </React.Fragment>
    )
   }


export default class ItemList extends Component {
    state = {
        addItemMenu: false,
        previewItem: false,
        simulateItem: false,
        reArrangeActive: false,
        dummyData: [],
        itemTableData: [],
        addItemCardData: [],
        singleItem: null,
        addItemsLesson: false,
        addSelected: false
    }
    componentDidMount() {
        let dummyData = [];

        for (let index = 1; index <= 10; index++) {
            dummyData.push({
                index,
                itemCode: `ACT-E-Q${index}`,
                itemType: 'Multiple Choice',
                preview: `Oh, king eh? Very nice. 
                            And how'd you get that, 
                            eh? By exploiting the workers. 
                            <span className='underlined_item'>By hanging on to outdated</span> imperialist dogma 
                            which perpetuates the economic and social differences 
                            in our society. If there's ever gonna be any progress...`,
                tags: 'hard-question, mess-these-kids-up, questionable-answer',
                nodes: `Writer's Goal`,
                answerChoices: {
                    answer001: 'Bring out your dead',
                    answer002: `Well you can't expect to wield supreme executive power just 'cause some watery tart threw a sword at you!`,
                    answer003: `Come back here and take what's coming to you. I'll bite your legs off!`,
                    answer004: `All right, all right, not biscuits, but lets kill him anyway.`
                }
            })
        }

        this.setState({
            dummyData: dummyData,
            itemTableData: dummyData,
            addItemCardData: dummyData
        })
    }
  
    componentDidUpdate(prevProps) {
        if(this.props.activeCard !== 'addSelectedItems' && (prevProps.activeCard !== this.props.activeCard)){
            this.setState({ addSelected : false })
        }
    }


    handleRightColums = (type, value) => {
        let rightColumToggles = {
            addItemMenu: false,
            previewItem: false,
            simulateItem: false
        }

        delete rightColumToggles[type]
        
        if(type === 'simulateItem'){
            this.props.toggleRightCol('SimulateItem')
            this.props.handleView(value)
        }
        if(type === 'previewItem'){
            this.props.toggleRightCol('PreviewItem')
            this.props.handleView(value)
        }
        
        this.setState({
            [type]: true,
            singleItem: value ? value : null,
            ...rightColumToggles
        })
    }
  
    itemsFilter = (e, type) => {
        const { dummyData } = this.state

        e.target.value !== '' ?
            this.setState({
                [type]: dummyData.filter(val =>
                    val.itemCode.toLowerCase().search(e.target.value.toLowerCase()) !== -1)
            }) :
            this.setState({
                [type]: dummyData
            })

    }

    tableScrollHandle = (e) => {

        [...document.getElementsByClassName('row-side-menu')]
            .map(ele => ele.style.transform = `translate(0px, -${e.target.scrollTop + 50}px)`)
    }

    addItemsLesson = () => {
        this.setState(state => ({ addItemsLesson : !state.addItemsLesson }))
    }
    addSelected = () => {
        this.props.toggleRightCol('addSelectedItems')
        this.setState(state => ({ addSelected : !state.addSelected }))
    }

    render() {
        const {
            addItemMenu,
            addItemsLesson,
            itemTableData,
            addSelected
        } = this.state

        return (
            <Row>
                <Col className={`edit-lesson`} style={{ opacity : addSelected ? '0.7' : '1' }} sm="12">
                    <LessonCard
                        iconClass="items-icon"
                        heading="Item List"
                        isCollapsable
                        headerButtons={[
                         <Button className={`add-btn ${addItemMenu ? 'active' : ''}`} onClick={this.addItemsLesson}>+ Add Items to Lesson(s)</Button>
                        ]}>

                        <div className='filter-input'>
                            <Input onChange={e => this.itemsFilter(e, 'itemTableData')} type="text" name="filter-input" placeholder='Search' />
                        </div>
                        <div className='table-container'>
                        {addItemsLesson && <div className="mt-2 ml-2 mr-1 text-center font-weight-bold">Select all of the items you want to add to lessons. Once you're done selecting items, click the "Add Selected Items to Lessons" button at the bottom of this card.</div>}
                            <div onScroll={this.tableScrollHandle} className='items-bank-left-container' >
                                <Table style={{ marginLeft: addItemsLesson ? '-20px' : '0' }} striped hover
                                 className={`items-bank-table ${addItemsLesson ? 'mt-2' : ''}`}>
                                    <div id='drag-row'></div>
                                    <thead className='card-header'>
                                        <tr>
                                            {addItemsLesson &&
                                                <th style={{backgroundColor: '#e6e7e8', border: 0}} ></th>}
                                            <th>Item Code</th>
                                            <th>Item Type</th>
                                            <th>Nodes</th>
                                            <th>Tags</th>
                                            <th>Preview</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                   {itemTableData.map((value, index) => ( <ListItems value={value} index={index} addItemsLesson={addItemsLesson} handleRightColums={this.handleRightColums}  />))}
                                   </tbody>      
                                </Table>
                            </div>
                                            {addItemsLesson && <div className="text-center mx-0 my-2"><Button onClick={this.addSelected} className={`add-btn p-3`}>Add Selected Items to Lesson(s)</Button></div> }
                        </div>
                    </LessonCard>
                </Col>
            </Row>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorItemsCards/ItemList.js